export enum InstitutionNoteChannel {
  CREATE = 'institutionNote::create',
  EDIT = 'institutionNote::patch',
  DELETE = 'institutionNote::delete',
}
